module.exports = __webpack_public_path__ + "img/profit_loss_share_bg.d91e0853.png";